import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Button,
  Box,
  Chip,
  IconButton
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const FilterPanel = ({
  workingFilter,
  setWorkingFilter,
  statusFilter,
  setStatusFilter,
  majorIssueFilter,
  setMajorIssueFilter,
  minorIssueFilter,
  setMinorIssueFilter,
  allocatedToFilter,        // Add this prop
  setAllocatedToFilter,     // Add this prop
  onResetFilters
}) => {

  // Options for major issues in the select field
  const majorIssueOptions = [
    "Fan",
    "Speaker",
    "Microphone",
    "Damaged Screen",
    "Faulty Battery",
    "Overheating",
    "Malfunctioning Keyboard",
    "Broken Ports",
    "Hard Drive Issues",
    "Defective Motherboard",
    "Audio Problems",
    "Graphics Card Issues",
    "Water Damage",
    "USB Ports",
  ];

  // Options for minor issues in the select field
  const minorIssuesOptions = [
    "Cosmetic Wear",
    "Loose Hinges",
    "Dead Pixels",
    "Fading Keyboard",
    "Small Battery Capacity Loss",
    "Minor Software Issues",
    "Port Wear",
    "Touchpad Sensitivity",
    "CMOS Battery",
    "RAM Issue",

  ];

  const [showAllocatedToFilter, setShowAllocatedToFilter] = useState(false);
  const [allocatedToOptions, setAllocatedToOptions] = useState([]);

  useEffect(() => {
    const fetchAllocatedToOptions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_NgoInformationApi}?type=registration`
        );
        const responseData = await response.json();
        const filtered = responseData.data.filter((ngo) => 
          ['Approved', 'Delivered', 'Dispatched'].includes(ngo.Status)
        );
        const names = filtered.map((ngo) => ngo.organizationName);
        setAllocatedToOptions(names);
      } catch (err) {
        console.error('Error fetching allocated to options:', err);
      }
    };

    fetchAllocatedToOptions();
  }, []);

  return (
    <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Filters
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <Typography variant="subtitle2" gutterBottom>
              Processing Status
            </Typography>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              variant="outlined"
              size="small"
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="LAPTOP_RECEIVED">LAPTOP_RECEIVED</MenuItem>
              <MenuItem value="REFURBISHMENT_TESTING">REFURBISHMENT_TESTING</MenuItem>
              <MenuItem value="QC_CHECK">QC_CHECK</MenuItem>
              <MenuItem value="DISTRIBUTION">DISTRIBUTION</MenuItem>
              <MenuItem value="POST_DEPLOYMENT_15D">POST_DEPLOYMENT_15D</MenuItem>
              <MenuItem value="MONTHLY_MONITORING">MONTHLY_MONITORING</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <Typography variant="subtitle2" gutterBottom>
              Major Issue
            </Typography>
            <Select
              value={majorIssueFilter}
              onChange={(e) => setMajorIssueFilter(e.target.value)}
              variant="outlined"
              size="small"
            >
              <MenuItem value="all">All</MenuItem>
              {/* <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem> */}
              <MenuItem disabled sx={{ borderTop: '1px solid #eee', py: 1 }}>
                <Typography variant="caption">Specific Issues</Typography>
              </MenuItem>
              {majorIssueOptions.map((issue) => (
                <MenuItem key={issue} value={issue}>{issue}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <Typography variant="subtitle2" gutterBottom>
              Minor Issue
            </Typography>
            <Select
              value={minorIssueFilter}
              onChange={(e) => setMinorIssueFilter(e.target.value)}
              variant="outlined"
              size="small"
            >
              <MenuItem value="all">All</MenuItem>
              {/* <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem> */}
              <MenuItem disabled sx={{ borderTop: '1px solid #eee', py: 1 }}>
                <Typography variant="caption">Specific Issues</Typography>
              </MenuItem>
              {minorIssuesOptions.map((issue) => (
                <MenuItem key={issue} value={issue}>{issue}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {showAllocatedToFilter && (
            <Grid item xs={12} md={2.9}>
              <FormControl fullWidth>
                <Typography variant="subtitle2" gutterBottom>Allocated To</Typography>
                <Select
                  value={allocatedToFilter}
                  onChange={(e) => setAllocatedToFilter(e.target.value)}
                  variant="outlined"
                  size="small"
                  displayEmpty
                >
                  <MenuItem value="">All</MenuItem>
                  {allocatedToOptions.map((name) => (
                    <MenuItem key={name} value={name}>{name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          <IconButton onClick={() => setShowAllocatedToFilter(prev => !prev)}>
            {showAllocatedToFilter ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Grid>

        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onResetFilters}
          >
            Reset Filters
          </Button>
        </Grid>
      </Grid>

      {/* Applied filters chips */}
      {(statusFilter !== 'all' || majorIssueFilter !== 'all' || minorIssueFilter !== 'all' || allocatedToFilter) && (
        <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="subtitle2">Applied Filters:</Typography>
          {statusFilter !== 'all' && (
            <Chip
              label={`Status: ${statusFilter}`}
              color="secondary"
              onDelete={() => setStatusFilter('all')}
            />
          )}
          {majorIssueFilter !== 'all' && (
            <Chip
              label={majorIssueFilter === 'yes' ? 'Major Issue: Yes' :
                majorIssueFilter === 'no' ? 'Major Issue: No' :
                  `Major Issue: ${majorIssueFilter}`}
              color="error"
              onDelete={() => setMajorIssueFilter('all')}
            />
          )}
          {minorIssueFilter !== 'all' && (
            <Chip
              label={minorIssueFilter === 'yes' ? 'Minor Issue: Yes' :
                minorIssueFilter === 'no' ? 'Minor Issue: No' :
                  `Minor Issue: ${minorIssueFilter}`}
              color="warning"
              onDelete={() => setMinorIssueFilter('all')}
            />
          )}
          {allocatedToFilter && (
            <Chip
              label={`Allocated To: ${allocatedToFilter}`}
              color="info"
              onDelete={() => setAllocatedToFilter('')}
            />
          )}

        </Box>
      )}
    </Paper>
  );
};

export default FilterPanel;

